import type { BlockContentAndMedia } from 'types/block-content-and-media';
import React from 'react';
import dynamic from 'next/dynamic';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import Figure from './figure';

const VideoYoutube = dynamic(() => import('./video-youtube'));

const ContentAndMedia: React.FC<BlockContentAndMedia> = ({
  sectionId,
  title,
  label,
  content,
  image,
  youtubeVideoId,
  mediaLabel,
}) => {
  return (
    <Wrap id={sectionId}>
      <div className="grid lg:grid-cols-2 lg:gap-x-14 gap-y-8">
        <div className="grid gap-y-8 lg:gap-y-12">
          <div className="lg:text-left max-w-2xl">
            {title?.length > 0 && (
              <HeadingBody className="!mb-2" {...{ level: '2', title }} />
            )}
            {label?.length > 0 ? <p>{label}</p> : null}
          </div>
          {content?.length > 0 ? (
            <WysiwygContent
              content={content}
              extraLargeParagraph={true}
              className="!text-lg lg:!text-2xl leafwell-add-margin-top-to-li"
            />
          ) : null}
        </div>
        <div className="grid gap-y-4">
          {image && <Figure {...image} />}
          {youtubeVideoId && (
            <VideoYoutube
              youtubeVideos={Array({
                youtubeVideoId: youtubeVideoId,
                image: null,
                playButtonStyle: 'secondary',
              })}
              videoSize="large"
              variant="none"
              sectionId=""
              removePadding={true}
            />
          )}
          {mediaLabel?.length > 0 ? (
            <p className="text-sm">{mediaLabel}</p>
          ) : null}
        </div>
      </div>
    </Wrap>
  );
};

export default ContentAndMedia;
